import { CREATE_DUPLICATELINE_START, CREATE_REVISION_START, UPDATE_REVISION_START } from './revTypes';
import { takeLatest, put, call, all, delay, fork } from "@redux-saga/core/effects";
import { createDuplicateLineAPI, createRevisionAPI, crtedRevDtlsPostAPI, getPkgsAPI, updateRevisionAPI, updtedRevDtlsPostAPI } from "../../apis/pgapis";

import { addTimeOutPayloadAct, createUpdtReviFailAct, createUpdtReviSuccAct, updtTagPBarStatusAct, updtTimeOutStatusAct, createDuplicateLineFail, createDuplicateLineSucc } from './revAction';
import { showLoader, refreshApp } from "../ctrl/ctrlActions";
import { postpricingdataSuccess, upPkgFailAct, upPkgSuccAct } from '../project/projActions';
import toastr from 'toastr';
import "toastr/build/toastr.min.css";

let temp = 0;
let payLdcount = 0;
let totalReqLeft = 0;


function* crRev({ payload: pl }) {
  let payload = pl.payload ? pl.payload : pl
  console.log(payload);
  yield put(showLoader(true));
  yield put(updtTimeOutStatusAct(false));
  let fromNo = 0;
  let toNo = 0;
  let sdata = [];
  //console.log('from saga fork payload ', payload.recordsArr)
  //console.log('from saga fork payload pkg', payload)
  const pl_count = payload.recordsArr?.length;
  let splitNumber = new Array(Math.floor(pl_count / 1200)).fill(1200).concat(pl_count % 1200);
  if (payload.type && payload.type === "Flow") {
    splitNumber = new Array(Math.floor(pl_count / 900)).fill(900).concat(pl_count % 900);
  }
  if (payload.from && payload.from === "singleClickMultiUpdate") {
    splitNumber = new Array(Math.floor(pl_count / 5000)).fill(5000).concat(pl_count % 5000);
  }
  splitNumber = splitNumber.filter(function (val) {
    return val !== 0;
  });
  // console.log("splitNumber", splitNumber)

  for (let i = 0; i < splitNumber.length; i++) {
    sdata = [...payload?.recordsArr];
    let count = splitNumber[i];
    fromNo = toNo;
    toNo = toNo + count;

    let recordsArr1 = sdata?.splice(fromNo, count)

    const data_with_tech_type_key = {};
    let data = {}



    if (payload.from && payload.from === "singleClickMultiUpdate") {
      data = recordsArr1
    } else {


      recordsArr1.forEach(e => {

        if (Object.keys(data_with_tech_type_key).includes(e.gen_technology_type)) {
          data_with_tech_type_key[e.gen_technology_type].push(e)
        } else {
          data_with_tech_type_key[e.gen_technology_type] = [e]
        }
      })

      let dataWithProdDescKeys = {}
      for (let techTypeEle in data_with_tech_type_key) {
        const ttDataarr = data_with_tech_type_key[techTypeEle]
        console.log(ttDataarr);

        const dataobj = {};

        ttDataarr.forEach(e => {
          let obj = {}
          obj['product_description'] = e.gen_prod_desc ? e.gen_prod_desc : ""
          obj['instrument_type'] = e.gen_instrument_type ? e.gen_instrument_type : ""
          obj['technology_id'] = null
          obj['project_id'] = e.project_id ? e.project_id : ""
          obj['package_id'] = e.package_id ? e.package_id : ""
          obj['package_name'] = e.package_name ? e.package_name : ""
          obj['technology_name'] = e.technology_name ? e.technology_name : ""
          obj['created_by'] = e.created_by ? e.created_by : ""
          obj['creation_date'] = e.creation_date ? e.creation_date : ""
          obj['last_updatedby'] = e.last_updatedby ? e.last_updatedby : ""
          obj['last_updatedate'] = e.last_updatedate ? e.last_updatedate : ""
          obj['start_date'] = e.start_date ? e.start_date : null
          obj['end_date'] = null
          obj['enabled_flag'] = null
          obj['selected'] = "Y"
          obj['revision'] = e.revision ? e.revision : ""

          if (!Object.keys(dataobj).includes(e.gen_prod_desc)) {
            //dataobj[e.gen_prod_desc].push(e)
            dataobj[e.gen_prod_desc] = obj
          }
          // else {
          //   dataobj[e.gen_prod_desc] = [e]
          // }
        })
        dataWithProdDescKeys[techTypeEle] = dataobj

      }

      data["techTypeData"] = dataWithProdDescKeys
      data["tags"] = data_with_tech_type_key
      data["package_id"] = payload.pkg.package_id
      data["project_id"] = payload.pkg.project_id
      data["revision"] = payload.pkg.revision + ""
      data["revision_comments"] = payload.revision_comments || ""
      console.log('from saga obj2', data)
    }
    if (count !== 0) {
      totalReqLeft += 1;
      yield fork(crUpdtRevs, { tagsData: data, from: payload.from || "", pkg: payload.pkg, tagCnt: pl_count, count, type: payload.type, multiTagPost: payload.multiTagPost });
    }
    if (pl_count > 4000 && i % 6 === 0) {
      yield delay(1000);
    } else {
      let dly = 0;
      if (totalReqLeft >= 3) {
        dly = 2000;
      }
      if (totalReqLeft >= 4) {
        dly = 4000;
      }
      if (totalReqLeft >= 6) {
        dly = 6000;
      }
      if (totalReqLeft >= 10) {
        dly = 8000;
      }
      console.log("totalReqLeft " + totalReqLeft + " delay " + dly);
      yield delay(dly);
    }

  }
}

function* crUpdtRevs(payload) {
  let batchApi = null;
  switch (payload.pkg.mode) {
    case 'NEW':
      batchApi = createRevisionAPI
      break;
    case 'UPDATE':
      batchApi = updateRevisionAPI
      break;
    default:
      console.error(`Sorry, Mode is missing.`);
  }

  let response = yield call(batchApi, payload)
  payLdcount += payload.count

  // if (!response?.response?.status) {
  //   console.log("cancelapi failed Triggered");
  //    console.log(payload);
  // } 

  totalReqLeft -= 1;


  if (response.response?.status === 500 || response.response?.status === 502 || response?.status != 200) {
    temp = 1
    console.log('response.response', response.response);
    // its used for saving the failed tags further used for retry
    //yield put(addTimeOutPayloadAct(JSON.parse(response.response.config.data).tags));
  }
  console.log('from saga crRevs payload ', payLdcount + "--" + payload.tagCnt);

  if (response.status === 200) {
    yield put(updtTagPBarStatusAct({ tagsPosted: payload.count }));
  }

  if (temp === 0 && payload.tagCnt === payLdcount && response.status === 200) {
    temp = 0
    payLdcount = 0
    totalReqLeft = 0;
    console.log('after response ', response.response);
    //  yield call(crUpdRevsPostApi, { payload, response });
    let ttlCnt = payload.pkg.ttlTagCount
    yield put(createUpdtReviSuccAct());
    yield put(showLoader(false));
    //yield call(fetchAlltags, { ttlCnt, payload });

  } else if (temp === 1 && payload.tagCnt === payLdcount) {
    totalReqLeft = 0;
    temp = 0
    payLdcount = 0
    // its used for triggering the retry process with failed tags
    //yield put(updtTimeOutStatusAct(true));

    // this should be comment or its used in case of only showing error message
    yield put(createUpdtReviFailAct(response.response.data.detail));
    yield put(showLoader(false));

  }

  // else{
  //   yield put(showLoader(false));
  //   console.log("Error onCreateRevisionAsync ");
  //   yield put(createUpdtReviFailAct());
  // }
  //yield put(upPkgSuccAct(response.data[0])); yield put(createUpdtReviSuccAct(response.data))
}

const sizePL = 5000;
let failedArr = [];
let processedDataCount = 0;
let failProcessed = 0

function* fetchAlltags({ ttlCnt, payload }) {
  var splitNumber = new Array(Math.floor(ttlCnt / sizePL)).fill(sizePL).concat(ttlCnt % sizePL);
  var fromNo = 0;
  var toNo = 0;
  console.log(payload)
  console.log(splitNumber)
  processedDataCount += toNo;

  for (let i = 0; i < splitNumber.length; i++) {

    let count = splitNumber[i];
    fromNo = toNo + 1;
    toNo = count < sizePL ? ttlCnt : toNo + count;
    // console.log('from saga fork count ', fromNo + "-to-" + toNo +"-count-" +count)
    if (count !== 0) {
      console.log('from saga fork count ', fromNo + "-to-" + toNo + "-count-" + count)
      yield fork(crUpdRevsPostApi, { ...payload, fromNo: fromNo, toNo: toNo, count });

    }
    yield delay(2000);

  }

}


// let tempCounter=0
// function* crUpdRevsPostApi({ payload, response }) {

//   if (response.status === 200) {
//     try {
//       const params = [
//         {
//           "project_id": payload.pkg.project_id,
//           "package_id": payload.pkg.package_id,
//           "revision": payload.pkg.revision,
//           "mode": payload.pkg.mode
//         }
//       ]

//       let afterBatchApi = null
//       switch (payload.pkg.mode) {
//         case 'NEW':
//           afterBatchApi = crtedRevDtlsPostAPI
//           break;
//         case 'UPDATE':
//           afterBatchApi = updtedRevDtlsPostAPI
//           break;
//         default:
//           console.error(`Sorry, mode is missing.`);
//       }

//       let response = yield call(afterBatchApi, params);


//       if (response.status === 200) {
//         console.log(response);
//         yield put(createUpdtReviSuccAct());
//         tempCounter=0
//         try {
//           let payLd = `pid=${payload.pkg.project_id}&pkgid=${payload.pkg.package_id}`;
//           //yield put(fPkgsAct({ fPkgs: payLd }));
//           const fPkgs = { fPkgs: payLd }
//           const response = yield call(getPkgsAPI, fPkgs);
//           console.log(response)
//           if (response.status === 200) {
//             yield put(upPkgSuccAct(response.data[0]));
//             yield put(showLoader(false));
//           }

//         }
//         catch (e) {
//           yield put(showLoader(false));
//           console.log("Error updateProjectFailAct ", e);
//           yield put(upPkgFailAct(e));
//         }
//       }

//     } catch (e) {
//       if(e.response?.status===500 && tempCounter<=5){
//         console.log(e.response.status)
//         tempCounter++;
//         yield call(crUpdRevsPostApi, { payload, response });
//       }else{ 
//         tempCounter=0;
//       yield put(createUpdtReviFailAct(e));
//       yield put(showLoader(false));
//       console.error(e)
//       }
//     }

//   }
// }


let tempCounter = 0
function* crUpdRevsPostApi(payload) {

  console.log(payload)

  const params = [
    {
      "project_id": payload.pkg.project_id,
      "package_id": payload.pkg.package_id,
      "revision": payload.pkg.revision,
      "mode": payload.pkg.mode,
      "from_seq": payload.fromNo,
      "type": payload.type,
      "to_seq": payload.toNo
    }
  ]

  let afterBatchApi = null
  switch (payload.pkg.mode) {
    case 'NEW':
      afterBatchApi = crtedRevDtlsPostAPI
      break;
    case 'UPDATE':
      afterBatchApi = updtedRevDtlsPostAPI
      break;
    default:
    //console.error(`Sorry, mode is missing.`);
  }

  let response = yield call(afterBatchApi, params);


  processedDataCount += payload.count;
  // console.log("count", payload.count)
  // console.log("processedDataCount", processedDataCount)
  let indx = failedArr.findIndex(e => e.fromNo === payload.fromNo);

  //console.log(response.response);
  //console.log(response);
  //console.log(payload);

  if (response.response?.status === 500 || response.response?.status === 502) {
    //console.log(response.response);
    console.log(payload);
    if (indx === -1) {
      failedArr.push(payload)
    }

    //  console.log(failedArr);
    failProcessed += payload.count;
    //console.log("failProcessed", failProcessed)
  }

  // yield put(fetchAllProjectSuccAct(response))
  if (response.status === 200) {
    if (indx !== -1) {
      failedArr.splice(indx, 1);
    }
  }


  if (processedDataCount === payload.pkg.ttlTagCount) {
    console.log(failedArr);
    processedDataCount = 0;
    let f = failProcessed;
    failProcessed = 0
    let tempArr = [...failedArr];
    failedArr = [];
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {

        let oj = { ...tempArr[i], pkg: { ...tempArr[i].pkg, ttlTagCount: f } }
        //oj["payload"] = {...oj.payload,ttlCnt:f}
        //console.log(oj)
        yield fork(crUpdRevsPostApi, oj)
        yield delay(2000);
      }
    } else {
      yield put(createUpdtReviSuccAct());
      if (payload.pkg.mode == "UPDATE" && payload.pkg.apiAction == 'UpdPPAprice') {
        yield put(postpricingdataSuccess({ updTags: payload.recordsArr })); //, 
        // console.log("PPA CALLED");
      }
      if (payload.pkg.apiSuccess == 'API_SUCCESS') //alert for Data inserted successfully
      {
        toastr.success("New Valid Tags imported successfully to PPA");
      }



      try {
        if (!payload.multiTagPost && payload.from != 'singleClickMultiUpdate') {
          let payLd = `pid=${payload.pkg.project_id}&pkgid=${payload.pkg.package_id}`;
          //yield put(fPkgsAct({ fPkgs: payLd }));
          const fPkgs = { fPkgs: payLd }
          const response = yield call(getPkgsAPI, fPkgs);
          //console.log(response)
        }
        if (response.status === 200) {
          if (response.data) {
            yield put(upPkgSuccAct(response.data[0]));
          }
          yield put(showLoader(false));
        }

      }
      catch (e) {
        if (e?.response?.status === 403) { yield put(refreshApp(true)) }
        yield put(showLoader(false));
        // console.log("Error updateProjectFailAct ", e);
        yield put(upPkgFailAct(e));
      }

    }
  }






  //------
  // if(e.response?.status===500 && tempCounter<=5){
  //   console.log(e.response.status)
  //   tempCounter++;
  //   yield call(crUpdRevsPostApi, { payload, response });
  // }else{ 
  //   tempCounter=0;
  // yield put(createUpdtReviFailAct(e));
  // yield put(showLoader(false));
  // console.error(e)
  // }



}



// export function* onCreateRevisionAsync(payload) {
//   /*try {
//     console.log('from saga fork payload ',payload)
//     yield call(crRev, payload);
//   } catch (e) {
//     console.log("onCreateRevisionAsync Error:", e)
//   }*/
//    try {
//       yield put(showLoader(true));
//       //console.log('from saga batch payload ',payload)
//       const response = yield call(createRevisionAPI, payload);
//       //console.log("-----TTT-----",response);
//       if (response.status === 200) {
//       yield put(createUpdtReviSuccAct());

//      // yield put(upPkgSuccAct(response.data[0]));
//       yield put(showLoader(false));
//       }
//     } catch (e) {
//       yield put(showLoader(false));
//       console.log("Error onCreateRevisionAsync ", e);
//       yield put(createUpdtReviFailAct(e));
//     }
//   }

export function* onCreateRevisionAsync({ payload }) {
  console.log("onCreateRevisionAsync", payload)
  /*try {
    console.log('from saga fork payload ',payload)
    yield call(crRev, payload);
  } catch (e) {
    console.log("onCreateRevisionAsync Error:", e)
  }*/
  try {

    yield put(showLoader(true));
    //console.log('from saga batch payload ',payload)
    const response = yield call(createRevisionAPI, payload);
    // console.log("-----TTT-----", response);
    yield call(crUpdRevsPostApi, { payload, response });
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(showLoader(false));
    // console.log("Error onCreateRevisionAsync ", e);
    yield put(createUpdtReviFailAct(e));
  }
}
export function* onCreateDuplicateLineAsync({ payload }) {
  try {
    const response = yield call(createDuplicateLineAPI, payload)
    if (response.status === 200) {
      yield put(createDuplicateLineSucc(response.data));
      yield put(showLoader(false));

    }
  } catch (error) {
    console.log("Error onCreateDuplicateLineAsync", error);
    yield put(createDuplicateLineFail(error));
    yield put(showLoader(false));
  }
}

export function* onCreateRevision() {
  yield takeLatest(CREATE_REVISION_START, crRev);
}


// export function* onUpdateRevisionAsync(payload) {
//   try {
//     yield put(showLoader(true));

//     const response = yield call(updateRevisionAPI, payload);
//     if (response.status === 200) {
//       yield put(createUpdtReviSuccAct(response.data));
//       yield put(upPkgSuccAct(response.data[0]));
//       yield put(showLoader(false));
//     }
//   } catch (e) {
//     yield put(showLoader(false));
//     console.log("Error onUpdateRevisionAsync ", e);
//     yield put(createUpdtReviFailAct(e));
//   }
// }


export function* onUpdateRevision() {
  yield takeLatest(UPDATE_REVISION_START, crRev);
}
export function* onDuplicateLine() {
  yield takeLatest(CREATE_DUPLICATELINE_START, onCreateDuplicateLineAsync);
}